import {
  REQUEST_STRAT,
  RECEIVE_STRAT,
  STRAT_FAILED,
  REQUEST_SP,
  RECEIVE_SP,
  SP_FAILED,
  API_CALL
} from './types';

export const getStrategies = () => ({
  type: API_CALL,
  onRequest: REQUEST_STRAT,
  onResponse: RECEIVE_STRAT,
  onError: STRAT_FAILED,
  responseKey: 'strategies',
  payload: {
    method: 'GET',
    url: '/strategies'
  }
});

export const getSalesProducts = () => ({
  type: API_CALL,
  onRequest: REQUEST_SP,
  onResponse: RECEIVE_SP,
  onError: SP_FAILED,
  responseKey: 'salesProducts',
  payload: {
    method: 'GET',
    url: '/salesproducts'
  }
});
